import { jwtDecode } from "jwt-decode";

export interface IBaseTokenData {
  UserId: string;
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  nbf: number;
}

export interface ITokenData extends IBaseTokenData {
  FirstName: string;
  LastName: string;
  UserName: string;
  Email: string;
  PhoneNumber: string;
  CurrentAccount: string;
}

export interface IRefreshTokenData extends IBaseTokenData {
  salt: string;
}

export const decodeToken = <Token = ITokenData | IRefreshTokenData>(
  token: string
): Token => {
  return jwtDecode(token);
};
